import { ExternalLink, Mail } from "lucide-react";
import { Reveal } from "@/components/Reveal";

// Verified double-opt-in signup for the dedicated Atlantic Bridge Briefing list (#3).
// Keep the Institute contact form on Netlify; newsletter enrollment is handled by Brevo.
const BREVO_SIGNUP_URL = "https://6eb0b771.sibforms.com/serve/MUIFAAIqEymafxTdwvvfLCz3BT8iNj2sMuI_5XFcy2khc8ORkvZsJXVBrhzIj04ehZdqCuw5w8qndsHwYGjcHU_8rbcUTFP0Eg8TemlXImDOAYBA_XSpOUccqxU04nZiF6yzmchikJMyxdDWba0X-jYfMLxVcK_b_ZXY7YRBMMIST5wqlg91YhAADtLmTb1sh3EM-YgQ2GJXvdDSKQ==";

export default function Newsletter() {
  return (
    <section id="newsletter" data-testid="newsletter-section" className="grain bg-atlantic py-24 lg:py-28">
      <div className="relative mx-auto grid max-w-7xl grid-cols-1 items-center gap-12 px-5 lg:grid-cols-12 lg:px-8">
        <Reveal className="lg:col-span-6">
          <p className="text-xs font-semibold uppercase tracking-[0.28em] text-gold">Founding readers invitation</p>
          <h2 className="mt-4 font-serif text-3xl leading-tight tracking-tight text-white sm:text-4xl lg:text-[2.75rem]">
            Atlantic Bridge Briefing
          </h2>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-white/70 sm:text-lg">
            Become a founding reader of independent reporting and policy analysis
            connecting Africa, the Caribbean and their diasporas. Our inaugural
            briefing examines what Ghana and Jamaica have actually delivered
            after their latest diplomatic engagements.
          </p>
          <p className="mt-4 max-w-xl text-sm leading-relaxed text-white/60">
            Edition 01: Beyond the Presidential Visit — evidence on the first
            Ghanaian nursing cohort, and questions still unanswered in trade,
            air connectivity, education, culture and reparatory justice.
          </p>
          <a
            href="/analysis/ghana-jamaica-presidential-visit"
            className="mt-5 inline-block text-sm font-semibold text-gold underline underline-offset-4 hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-gold"
          >
            Read the opening analysis
          </a>
        </Reveal>
        <Reveal delay={0.12} className="lg:col-span-5 lg:col-start-8">
          <div data-testid="newsletter-signup-panel" className="border border-white/15 bg-atlantic-light p-7 sm:p-9">
            <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.22em] text-white/60">
              <Mail size={14} className="text-gold" /> Email briefings
            </p>
            <p className="mt-4 text-sm leading-relaxed text-white/80">
              Join the founding readership at no cost. Open the secure signup
              page, enter your email and confirm your subscription from the
              verification message. We send editorial briefings only to
              confirmed subscribers.
            </p>
            <a
              href={BREVO_SIGNUP_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="newsletter-subscribe-button"
              className="mt-6 flex w-full items-center justify-center gap-2 bg-gold px-6 py-3.5 text-center text-sm font-semibold tracking-wide text-atlantic transition-colors hover:bg-gold-light focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold-light"
            >
              Join the Founding Readership <ExternalLink size={16} aria-hidden="true" />
            </a>
            <p className="mt-4 text-[11px] leading-relaxed text-white/50">
              Independent and non-partisan. Only confirmed subscribers receive
              briefings. Unsubscribe at any time using the link in our emails.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
